import React, { Component } from 'react';
import Dialog from '@mui/material/Dialog';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppBar from '@mui/material/AppBar';
import SuggestionCommentBlock from './SuggestionCommentBlock';
import UserSelect from '../Users/UserSelect'
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import authStore from '../../Auth/AuthStore';
import mainStore from '../../../MainStore';
import SuggestionsStore from './SuggestionsStore';
import SuggestionFilePanel from './SuggestionFilePanel';
import Menu from '@mui/material/Menu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import CloseIcon from '@mui/icons-material/Close';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import IconButton from '@mui/material/IconButton';
import SchedulleStore from '../Scheduller/SchedulleStore';
import InputAdornment from '@mui/material/InputAdornment';
import CopyIcon from '@mui/icons-material/FileCopy'; 
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Editor } from 'ckeditor5-custom-build/build/ckeditor';
import Fade from '@mui/material/Fade';
import Popper from '@mui/material/Popper';
import SuggestionCategorySelect from './SuggestionCategorySelect';
import VoteHistory from './VoteHistory';
import VoteControl from './VoteControl';

const SuggestionDialog = observer(class SuggestionDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isMenuOpen: false,
            anchorEl: null,
            fullscreen: true,
            comment: '',
            isPopperOpen: false
        };

        this.handleTabChange = this.handleTabChange.bind(this);
        this.handleRowCheckedChange = this.handleRowCheckedChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleMenuClick = this.handleMenuClick.bind(this);
        this.handleMenuClose = this.handleMenuClose.bind(this);
        this.handleCommentChange = this.handleCommentChange.bind(this);
        this.cloneSuggestion = this.cloneSuggestion.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.handleLookupSelect = this.handleLookupSelect.bind(this);
        this.handleVote = this.handleVote.bind(this);
        this.handleDeclineSuggestion = this.handleDeclineSuggestion.bind(this);
    }

    scrollPosition = 0

    componentDidUpdate() {
        this.scrollPosition = window.scrollY;
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event) {
        if (this.scrollPosition !== 0) {
            var pos = this.scrollPosition;
            this.scrollPosition = 0;
            window.scrollTo(0, pos);
        }
    }

    handleClose() {
        if (!SuggestionsStore.getSuggestion.id) {
            var res = window.confirm("Ты уверен что хочешь закрыть не сохраненную карточку?? Подумай!");
            if (res) {
                SuggestionsStore.closeSuggestionDialog();
            }
            else {
                return;
            }
        }
        SuggestionsStore.closeSuggestionDialog();
    }

    handleCostUpdate(costs) {
        this.setState({ costs: costs });
    }

    handleTabChange(event, newValue) {
        SuggestionsStore.setSelectedTab(newValue);
    }

    handleCommentChange(evt) {
        this.setState(evt);
    }

    handleSuggestionFieldChange = name => obj => {
        var suggestion = SuggestionsStore.getSuggestion;
        suggestion[name] = obj.name;
        suggestion[name + 'Id'] = obj.id;
        SuggestionsStore.setSuggestion(suggestion);
    }

    handleRowCheckedChange = name => evt => {
        var suggestion = SuggestionsStore.getSuggestion;
        suggestion[name] = evt.target.checked;
        SuggestionsStore.setSuggestion(suggestion);
    }

    handleDescriptionChange(text) {
        var suggestion = SuggestionsStore.getSuggestion;
        suggestion.text = text;
        SuggestionsStore.setSuggestion(suggestion);
    }

    handleRowDataChange = name => evt => {
        var suggestion = SuggestionsStore.getSuggestion;
        suggestion[name] = evt.target.value;
        SuggestionsStore.setSuggestion(suggestion);
    }

    cloneSuggestion() {
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Suggestion/Clone', {
            method: 'POST',
            body: JSON.stringify(SuggestionsStore.getSuggestion.id),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
                //scope.startSearch();
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    SuggestionsStore.openSuggestionDialog(result);
                }).catch((err) => console.log(err));
            }
        });
    }

    handleSave() {
        if (this.state.comment) {
            alert("У тебя остался неотправленный комментарий. УДАЛИ!!!!");
            return;
        }
        var scope = this;
        mainStore.setMaskVisible();
        var token = localStorage.getItem("token");
        fetch('api/Suggestion', {
            method: 'POST',
            body: JSON.stringify(SuggestionsStore.getSuggestion),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
                authStore.openLogin();
                mainStore.setMaskUnvisible();
                //scope.startSearch();
            }
            else {
                res.json().then((result) => {
                    SuggestionsStore.updateSuggestion(result);
                    if (SuggestionsStore.callback) {
                        SuggestionsStore.callback(result);
                        SuggestionsStore.setCallback(() => { });
                    }

                    mainStore.setMaskUnvisible();
                    SuggestionsStore.closeSuggestionDialog();
                }).catch((err) => console.log(err));
            }
        });
    }


    handleLookupSelect = (name, id) => (value) => {
        var suggestion = SuggestionsStore.getSuggestion;
        suggestion[id] = !!value ? value.id : '';
        suggestion[name] = !!value ? value.name : '';
        SuggestionsStore.setSuggestion(suggestion);
    }

    handleAssigneeChange(user) {
        var suggestion = SuggestionsStore.getSuggestion;
        suggestion.assigneeId = !!user ? user.id : '';
        suggestion.assignee = !!user ? user.name : '';
        suggestion.assigneeRoleId = !!user ? user.roleId : '';
        SuggestionsStore.setSuggestion(suggestion);
    }

    handleTesterChange(user) {
        var suggestion = SuggestionsStore.getSuggestion;
        suggestion.testerId = user.id;
        suggestion.tester = user.name;
        SuggestionsStore.setSuggestion(suggestion);
    }

    handleMenuClick(evt) {
        this.setState({ anchorEl: evt.currentTarget, isMenuOpen: true });
    }

    handleMenuClose() {
        this.setState({ anchorEl: null, isMenuOpen: false });
    }

    handleDeclineSuggestion() {
        const conf = window.confirm("Ты уверен что точно хочешь отклонить эту задачу? Инициатор получит уведомление");
        if (conf) {
            var scope = this;
            mainStore.setMaskVisible();
            var token = localStorage.getItem("token");
            fetch('api/Suggestion/Decline', {
                method: 'POST',
                body: JSON.stringify({ id: SuggestionsStore.getSuggestion.id }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                    authStore.openLogin();
                    mainStore.setMaskUnvisible();
                    //scope.startSearch();
                }
                else {
                    res.json().then((result) => {
                        mainStore.setMaskUnvisible();
                        var suggestion = SuggestionsStore.getSuggestion;

                        var suggestions = SuggestionsStore.getSuggestions.slice(0);
                        var index = suggestions.findIndex(w => w.id === SuggestionsStore.getSuggestion.id);
                        suggestions.splice(index, 1);
                        SuggestionsStore.setSuggestions(suggestions);
                        SuggestionsStore.closeSuggestionDialog();
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    handleDeleteSuggestion() {
        const conf = window.confirm("Ты уверен что точно хочешь прямо удалить эту задачу? Потом вернуть ее будет возможно!");
        if (conf) {
            var scope = this;
            mainStore.setMaskVisible();
            var token = localStorage.getItem("token");
            fetch('api/Suggestion/Delete', {
                method: 'POST',
                body: JSON.stringify({ id: SuggestionsStore.getSuggestion.id }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                    authStore.openLogin();
                    mainStore.setMaskUnvisible();
                    //scope.startSearch();
                }
                else {
                    res.json().then((result) => {
                        mainStore.setMaskUnvisible();
                        var suggestion = SuggestionsStore.getSuggestion;

                        var suggestions = SuggestionsStore.getSuggestions.slice(0);
                        var index = suggestions.findIndex(w => w.id === SuggestionsStore.getSuggestion.id);
                        suggestions.splice(index, 1);
                        SuggestionsStore.setSuggestions(suggestions);
                        SuggestionsStore.closeSuggestionDialog();
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    handleEditTime() {
        SchedulleStore.openSchedulleEditDialog({ suggestionId: SuggestionsStore.getSuggestion.id, date: new Date(), suggestionNumber: SuggestionsStore.getSuggestion.number, suggestionCaption: SuggestionsStore.getSuggestion.caption });
    }

    handleVote(result, value) {
        var suggestion = this.props.work;
        suggestion.rating = result.rating;
        suggestion.myRate = value;
        SuggestionsStore.updateSuggestion(suggestion);
    }

    getRateClass(rating) {
        if (rating > 10) return "best-rate";
        if (rating > 5) return "good-rate";
        if (rating >= 0) return "simple-rate";
        if (rating > -5) return "bad-rate";
        return "worst-rate";
    }

    getRateIconClass(rating) {
        if (rating === 5) return "best-rate-icon";
        if (rating === 4) return "good-rate-icon";
        if (rating === 3) return "simple-rate-icon";
        if (rating === 2) return "bad-rate-icon";
        if (rating === 1) return "worst-rate-icon";
        return "";
    }

    render() {
        return (
            <Dialog
                disableEnforceFocus={true}
                onClose={this.handleClose}
                aria-labelledby="customized-dialog-title"
                open={SuggestionsStore.isSuggestionDialogOpen}
                maxWidth="lg"
                fullWidth
                scroll="paper"
                fullScreen={this.state.fullscreen}
                className={"suggestion-kanban  " + (this.state.fullscreen ? "fullscreen" : "")}
                TransitionProps={{
                    onExit: () => console.log(window.scrollY)
                }}>
                <DialogTitle id="customized-dialog-title">
                    <div className="suggestion-dialog-number"><CopyToClipboard onCopy={() => { mainStore.openSnackbar('Скопировано в буфер обмена'); }} text={document.location.origin + '/suggestions?suggestion=' + encodeURIComponent(SuggestionsStore.getSuggestion.number)}><span>{SuggestionsStore.getSuggestion.number}</span></CopyToClipboard></div>
                    <div className="suggestion-dialog-caption">
                        <FormControl fullWidth>
                            <InputLabel htmlFor="adornment-caption">Заголовок</InputLabel>
                            <Input
                                id="adornment-caption"
                                value={SuggestionsStore.getSuggestion.caption}
                                onChange={this.handleRowDataChange('caption')}
                                endAdornment={<InputAdornment position="end"><IconButton aria-label="toggle password visibility" onClick={() => { }} size="large">
                                    <CopyToClipboard onCopy={() => { mainStore.openSnackbar('Скопировано в буфер обмена'); }} text={SuggestionsStore.getSuggestion.number + " " + SuggestionsStore.getSuggestion.caption}>
                                        <CopyIcon />
                                    </CopyToClipboard>
                                </IconButton>
                                </InputAdornment>}
                            />
                        </FormControl>
                    </div>
                    <div className="action-button-block">
                        <IconButton
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={this.handleMenuClick}
                            size="large">
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            anchorEl={this.state.anchorEl}
                            keepMounted
                            open={this.state.isMenuOpen}
                            onClose={this.handleMenuClose}
                            PaperProps={{
                                style: {
                                    maxHeight: 200,
                                    width: 200,
                                },
                            }}
                        >
                            <MenuItem key={0} onClick={this.handleDeleteSuggestion}>
                                Удалить
                            </MenuItem>
                            <MenuItem key={1} onClick={this.cloneSuggestion}>
                                Клонировать
                            </MenuItem>
                            {authStore.getIsAdmin && <MenuItem key={2} onClick={this.handleDeclineSuggestion}>
                                Отклонить
                            </MenuItem>}
                        </Menu>
                        {!this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': true }); }} size="large">
                            <FullscreenIcon />
                        </IconButton>
                        }
                        {this.state.fullscreen && <IconButton onClick={() => { this.setState({ 'fullscreen': false }); }} size="large">
                            <FullscreenExitIcon />
                        </IconButton>

                        }
                        <Button onClick={this.handleSave} color="primary" className="work-dialog-save-button">
                            Сохранить
                         </Button>
                        <IconButton onClick={this.handleClose} size="large">
                            <CloseIcon />
                        </IconButton>
                    </div>
                    {SuggestionsStore.getSuggestion.crmLink && <a href={SuggestionsStore.getSuggestion.crmLink} target="_blank" rel="noopener noreferrer">CRM</a>}
                </DialogTitle>
                <DialogContent dividers>
                    <div className="work-dialog-bar clearfix">
                        <AppBar position="static" color="default" className="short-appbar">
                            <Tabs
                                value={SuggestionsStore.getSelectedTab}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                            >
                                <Tab label="Главная" />
                                <Tab label="Голоса" />
                            </Tabs>
                        </AppBar>
                    </div>
                    {SuggestionsStore.getSelectedTab === 0 && <div>
                        <div className="clearfix">
                            <div className="card-inner-block card-inner-block-work">
                                <div className="left-work-block card-block  ">
                                    <CKEditor
                                        editor={Editor}
                                        data={SuggestionsStore.getSuggestion.text}
                                        onChange={(event, editor) => {
                                            const data = editor.getData();
                                            this.handleDescriptionChange(data);
                                        }}
                                    />
                                    <SuggestionFilePanel key={SuggestionsStore.getSuggestion.id} suggestionId={SuggestionsStore.getSuggestion.id} sessionId={SuggestionsStore.getSuggestion.sessionId} />
                                </div>
                                <div className="right-work-block">
                                    <div className="right-fields-work-block">    
                                        <Typography component={'span'} className="clearfix">
                                            <div className="tester-block">
                                                <UserSelect disabled="disabled" name={SuggestionsStore.getSuggestion.creator} label="Инициатор" />
                                            </div>
                                        </Typography>
                                        <Typography component={'span'} className="clearfix">
                                            <div className="tester-block">
                                                <UserSelect name={SuggestionsStore.getSuggestion.assignee} label="Ответственный" handleSelect={this.handleAssigneeChange} />
                                            </div>
                                        </Typography>
                                        <Typography component={'span'} className="clearfix">
                                            <div className="tester-block">
                                                <SuggestionCategorySelect label="Категория" name={SuggestionsStore.getSuggestion.category} handleSelect={this.handleSuggestionFieldChange("category")} />
                                            </div>
                                        </Typography>
                                        <Typography component={'span'} className="clearfix">
                                            <div className="half-block">
                                                <TextField required
                                                    id="standard-required"
                                                    label="Трудоемкость"
                                                    fullWidth
                                                    margin="none"
                                                    type="number"
                                                    value={SuggestionsStore.getSuggestion.planHours}
                                                    onChange={this.handleRowDataChange('planHours')}
                                                />
                                            </div>
                                        </Typography>
                                        <Typography component={'span'} className="clearfix">
                                            <div className="clearfix">
                                                <div className="half-block">
                                                    <TextField required
                                                        id="standard-required"
                                                        label="Состояние"
                                                        fullWidth
                                                        disabled
                                                        margin="none"
                                                        value={SuggestionsStore.getSuggestion.status}
                                                        onChange={this.handleRowDataChange('status')}
                                                    />
                                                </div>
                                            </div>
                                        </Typography>
                                        <Typography component={'span'} className="clearfix">
                                            <div className="clearfix half-block">
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={SuggestionsStore.getSuggestion.isFlagged} onChange={this.handleRowCheckedChange('isFlagged')} value="true" />
                                                    }
                                                    label="Флаг"
                                                />
                                            </div>
                                        </Typography>
                                        <Typography component={'span'} className="clearfix">
                                            <VoteControl suggestion={SuggestionsStore.getSuggestion} onVote={this.handleVote}/>
                                        </Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="comment-block-wrapper ">
                            <Typography>Комментарии</Typography>
                            <SuggestionCommentBlock key={SuggestionsStore.getSuggestion.id} suggestionId={SuggestionsStore.getSuggestion.id} sessionId={SuggestionsStore.getSuggestion.sessionId} handleParentChange={this.handleCommentChange} />
                        </div>
                    </div>}
                    {SuggestionsStore.getSelectedTab === 1 && <div class="card-inner-block card-inner-block-work"> <VoteHistory suggestionId={SuggestionsStore.getSuggestion.id} /> </div>}
                </DialogContent>
            </Dialog>
        );
    }
});

export default SuggestionDialog;